import React from "react";
import "./history-icon.css";

function HistoryIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26.869"
        height="22.76"
        viewBox="0 0 26.869 22.76"
      >
        <defs></defs>
        <g transform="translate(0.759 1)">
          <path
            className="history"
            d="M70.02,107.255l3.329,3.885a10.9,10.9,0,1,1,10.891,10.38,11.1,11.1,0,0,1-8.2-3.549"
            transform="translate(-70.02 -100.76)"
          />
          <path
            className="history"
            d="M203.754,153.74v7.927H198.21"
            transform="translate(-188.801 -150.034)"
          />
        </g>
      </svg>
    </>
  );
}

export default HistoryIcon;
